import React, {Component} from 'react';

class GoogleMapsEmbed extends Component {
    
    constructor(props, context) {
        super(props, context);
        
    }

    mapLoaded(){
        //console.log("GoogleMapsEmbed::mapLoaded()");
    }
    
    render() {
        let showMap = false
        const key = process.env.API_KEY_GOOGLE_MAPS
        let zoom = 11
        let mapTypeView, type, createSrc
        
      
        
        if (this.props.location) {
            let location = "ayuntamiento de ".replace(/ /g, "+") +this.props.location.municipio.replace(/ /g, "+") + "," + this.props.location.provincia.replace(/ /g, "+") + "," + this.props.location.pais.replace(/ /g, "+") + ","
            type = "place"
            createSrc = `https://www.google.com/maps/embed/v1/${type}?key=${key}&q=${location}&zoom=${zoom}`
            showMap = true
        } else if (this.props.center) {
            let center = this.props.center.lat + "," + this.props.center.lng
            let mapTypeView = "roadmap" //satellite
            type = "view"//"place" //view
            createSrc = `https://www.google.com/maps/embed/v1/${type}?key=${key}&center=${center}&zoom=${zoom}&maptype=${mapTypeView}`
            showMap = true
        } else if (this.props.origin && this.props.destination) {
            type = "directions"//"place" //view
            mapTypeView = "roadmap" //satellite
            let origin = "roadmap" //satellite
            let destination = "roadmap" //satellite
            // let avoid = "highways"//tolls|highways|ferries
            let mode = "driving"//driving, walking, bicycling, transit o flying
    
            if(this.props.origin.type === "coordinates"){
                origin = this.props.origin.lat + "," + this.props.origin.lng
            } else if(this.props.origin.type === "location"){
                origin = this.props.origin.municipio.replace(/ /g, "+") + "," + this.props.origin.provincia.replace(/ /g, "+") + "," + this.props.origin.pais.replace(/ /g, "+") + ","
            } else if(this.props.origin.type === "name"){
                origin = this.props.origin.name.replace(/ /g, "+")
            }else{
                console.error("GoogleMapsEmbed param origin sould be -> location | coordinates | name");
            }
    
            if(this.props.destination.type === "coordinates"){
                destination = this.props.destination.lat + "," + this.props.destination.lng
            } else if(this.props.destination.type === "location"){
                destination = this.props.destination.municipio.replace(/ /g, "+") + "," + this.props.destination.provincia.replace(/ /g, "+") + "," + this.props.destination.pais.replace(/ /g, "+") + ","
            } else if(this.props.destination.type === "name"){
                destination = this.props.destination.name.replace(/ /g, "+")
            }else{
                console.error("GoogleMapsEmbed param destination sould be -> location | coordinates | name");
            }
            
            createSrc = `https://www.google.com/maps/embed/v1/${type}?key=${key}&origin=${origin}&destination=${destination}&mode=${mode}&maptype=${mapTypeView}`
            showMap = true
        } else {
            console.error("GoogleMapsEmbed fault param center | location | directions");
        }
        // createSrc +="&callback=mapLoaded"
        
        return (
            <div>
                <iframe
                    width="100%"
                    height="350"
                    loading="lazy"
                    style={{borderRadius:"25px"}}
                    frameBorder="0"
                    // allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                    src={createSrc}
                    >
                </iframe>
            
            </div>
        );
    }
    
    componentWillMount() {
    
    }
    
    componentDidMount() {
    }
    
    componentDidUpdate() {
    
    }
    
    
}

export default GoogleMapsEmbed
